import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { length } from 'redux-form-validators';
import { isEmpty, toPlainObject } from 'lodash';

import {
    BRAND_NAME,
    CONTEXT_ROOT,
    IS_DEV,
    STATIC_ROOT,
    URL_PAGE_FACEBOOK,
    URL_PAGE_GOOGLEPLUS,
    URL_PAGE_TWITTER
} from '../../constants';
import { PATH } from '../../constants/path';
import { EMAIL_LENGTH } from '../../constants/form';
import { DEFAULT_LOCALE, LOCALES } from '../../constants/locale';

import { sendNewsletterSubscribeRequest, reset } from '../../services/newsletter/actions';

import { hasSubscribedToNewsletter } from '../../services/account/utils';

import LocalizedNavLink from '../router/LocalizedNavLink';
import { FormComponent, EmailInputFieldComponent } from '../form';
import { SuccessInfoComponent } from '../form/SuccessInfoComponent';

import './FooterComponent.scss';

const FORM_NAME = 'footer-newsletter-form';

const unlocalizedCurrentPath = () =>
    LOCALES.reduce((acc, cur) => acc.replace(`/${cur}/`, '/'), window.location.pathname);

class FooterComponent extends React.Component {
    submit = values => {
        const { sendNewsletterSubscribeRequest, reset } = this.props;
        const value = { subscribed: values ? true : false };

        sendNewsletterSubscribeRequest(value, () => {
            setTimeout(() => {
                reset();
            }, 3000);
        });
    };

    renderDevLanguageLink = () => {
        if (LOCALES.length) {
            return (
                <div>
                    Changer de langue :
                    {/* On force un reload de l'app pour changer de langue, seule solution trouvé pour le moment pour que le changement soit effectif */}
                    {LOCALES.map((locale, i, all) => (
                        <a
                            href={`${CONTEXT_ROOT}${
                                locale === DEFAULT_LOCALE ? '' : `/${locale}`
                            }${unlocalizedCurrentPath()}`}
                            key={i}>
                            {' '}
                            {locale} {i === all.length - 1 ? '' : '|'}
                        </a>
                    ))}
                </div>
            );
        }
    };

    renderDevLink = () => {
        return (
            <p>
                <LocalizedNavLink to="/guidelines" title="Guidelines">
                    Guidelines
                </LocalizedNavLink>
            </p>
        );
    };

    renderDevStuff = () => {
        if (IS_DEV) {
            return (
                <div className="conteneur conteneur-mobile">
                    <hr />
                    {this.renderDevLanguageLink()}
                    {this.renderDevLink()}
                </div>
            );
        }
    };

    renderSocialMedia = () => {
        const { i18n } = this.props;

        if (URL_PAGE_FACEBOOK || URL_PAGE_TWITTER || URL_PAGE_GOOGLEPLUS) {
            return (
                <div className="reseaux-sociaux">
                    <p className="bold hidden-mobonly">{i18n.TITLE_SMO}</p>
                    <div>
                        {URL_PAGE_FACEBOOK && (
                            <LocalizedNavLink
                                to={URL_PAGE_FACEBOOK}
                                target="_blank"
                                title={format(i18n.FACEBOOK_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/facebook-rond.png`}
                                    alt={format(i18n.FACEBOOK_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_TWITTER && (
                            <LocalizedNavLink
                                to={URL_PAGE_TWITTER}
                                target="_blank"
                                title={format(i18n.TWITTER_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/twitter-rond.png`}
                                    alt={format(i18n.TWITTER_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_GOOGLEPLUS && (
                            <LocalizedNavLink
                                to={URL_PAGE_GOOGLEPLUS}
                                target="_blank"
                                title={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/googleplus-rond.png`}
                                    alt={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                    </div>
                </div>
            );
        }
    };

    getUserInfo() {
        const { isAuthed, initialValues } = this.props;
        if (isAuthed) {
            return initialValues;
        }
    }

    renderNewsletterForm = () => {
        const {
            i18n,
            i18Form,
            isAuthed,
            user,
            requestSubmit,
            errorSubmit,
            successSubmit
        } = this.props;

        if (isAuthed && !hasSubscribedToNewsletter(user)) {
            return (
                <div>
                    <h3>{i18n.TITLE4}</h3>
                    <span>{i18n.RECEIVE_OFFER}</span>
                    <FormComponent
                        form={FORM_NAME}
                        onSubmit={this.submit}
                        initialValues={this.getUserInfo()}
                        destroyOnUnmount={false}
                        requestSubmit={requestSubmit}
                        errorSubmit={errorSubmit}
                        className="footer-newsletter-form"
                        submitText={i18n.SUBMIT_TEXT}>
                        <EmailInputFieldComponent
                            name="email"
                            classNameInputContainer=""
                            placeholder={i18Form.PLACEHOLDER_EMAIL}
                            isRequired
                            readOnly
                            validate={[
                                length({
                                    max: EMAIL_LENGTH,
                                    msg: format(i18Form.EMAIL_SIZE_ERROR, EMAIL_LENGTH)
                                })
                            ]}
                        />
                        <React.Fragment>
                            {successSubmit && (
                                <SuccessInfoComponent>
                                    <p>{i18n.SUBMIT_SUCCEEDED}</p>
                                </SuccessInfoComponent>
                            )}
                        </React.Fragment>
                    </FormComponent>
                </div>
            );
        }
    };

    showCmp() {
        window.Didomi.preferences.show();
    }

    render() {
        const { i18n, isAuthed, user } = this.props;

        return (
            <footer className="pieddepage">
                <div className="conteneur conteneur-mobile">
                    <div
                        className={`content grid-${
                            isAuthed && !hasSubscribedToNewsletter(user) ? '4' : '3'
                        } has-gutter`}>
                        <div>
                            <h3>{i18n.TITLE1}</h3>
                            <ul>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.FAQ_PATH}
                                        title={i18n.LINKS.FAQ.TITLE}
                                        name="footer-toFaq">
                                        {i18n.LINKS.FAQ.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.CONTACTREQUEST_PATH}
                                        title={i18n.LINKS.CUSTOMER_SERVICE.TITLE}
                                        name="footer-toCustomerService">
                                        {i18n.LINKS.CUSTOMER_SERVICE.TEXT}
                                    </LocalizedNavLink>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3>{i18n.TITLE2}</h3>
                            <ul>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.HOW_IT_WORK_PATH}
                                        title={i18n.LINKS.HOW_IT_WORKS.TITLE}
                                        name="footer-toHowItWorks">
                                        {i18n.LINKS.HOW_IT_WORKS.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.TOOLBAR_PATH}
                                        title={i18n.LINKS.TOOLBAR.TITLE}
                                        name="footer-toToolbarPage">
                                        {i18n.LINKS.TOOLBAR.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.TERMS_PATH}
                                        title={i18n.LINKS.TERMS.TITLE}
                                        name="footer-toTermsOfUse">
                                        {i18n.LINKS.TERMS.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.LEGAL_NOTICE_PATH}
                                        title={i18n.LINKS.LEGAL_NOTICE.TITLE}
                                        name="footer-toLegalNotice">
                                        {i18n.LINKS.LEGAL_NOTICE.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.TERMS_OF_SALES}
                                        title={i18n.LINKS.TERMS_OF_SALES.TITLE}
                                        name="footer-toTermsOfUse">
                                        {i18n.LINKS.TERMS_OF_SALES.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <span className="link" onClick={this.showCmp}>
                                        {i18n.CONSENT_CHOICES}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3>{i18n.TITLE3}</h3>
                            <ul>
                                <li>
                                    <a
                                        href="https://www.credit-agricole.fr/ca-aquitaine/particulier.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                            if (window.tag) {
                                                window.tag.click.send({
                                                    elem: this,
                                                    name: 'footer-toCreditAgricoleAquitaine',
                                                    type: 'navigation'
                                                });
                                            }
                                        }}>
                                        {i18n.LINKS.BANKS.CA_AQUITAINE}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.credit-agricole.fr/ca-des-savoie/particulier.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                            if (window.tag) {
                                                window.tag.click.send({
                                                    elem: this,
                                                    name: 'footer-toCreditAgricoleSavoie',
                                                    type: 'navigation'
                                                });
                                            }
                                        }}>
                                        {i18n.LINKS.BANKS.CA_SAVOIE}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.credit-agricole.fr/ca-illeetvilaine/particulier.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => {
                                            if (window.tag) {
                                                window.tag.click.send({
                                                    elem: this,
                                                    name: 'footer-toCreditAgricoleIleEtVilaine',
                                                    type: 'navigation'
                                                });
                                            }
                                        }}>
                                        {i18n.LINKS.BANKS.CA_ILE_ET_VILAINE}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        {this.renderNewsletterForm()}
                        {this.renderSocialMedia()}
                    </div>
                </div>
                {this.renderDevStuff()}
            </footer>
        );
    }
}

FooterComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapDispatchToProps = {
    sendNewsletterSubscribeRequest,
    reset
};

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.FOOTER,
        i18Form: state.i18n.feature.form,
        isAuthed: !isEmpty(state.authentication.token),
        user: user,
        initialValues: {
            email: user.email ? user.email : ''
        },
        requestSubmit: state.newsletterSubscription.fetching,
        errorSubmit: !isEmpty(state.newsletterSubscription.error),
        errorMessage: state.newsletterSubscription.error,
        successSubmit: state.newsletterSubscription.successSubmit
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/footer/FooterComponent.js